import { render, staticRenderFns } from "./selAddress.vue?vue&type=template&id=58ea326c&scoped=true"
import script from "./selAddress.vue?vue&type=script&lang=js"
export * from "./selAddress.vue?vue&type=script&lang=js"
import style0 from "./selAddress.vue?vue&type=style&index=0&id=58ea326c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea326c",
  null
  
)

export default component.exports